// src/services/reviewService.js
// Service pour les avis

import api from './api';

const reviewService = {
  /**
   * Récupérer les avis du client connecté
   * GET /api/reviews/my-reviews
   */
  async getMyReviews() {
    try {
      const response = await api.get('/reviews/my-reviews');
      return {
        success: true,
        reviews: response.data.reviews
      };
    } catch (error) {
      console.error('Erreur récupération avis:', error);
      return {
        success: false,
        reviews: [],
        message: error.response?.data?.message || 'Erreur lors de la récupération des avis'
      };
    }
  },

  /**
   * Créer un avis
   * POST /api/reviews
   */
  async createReview(reviewData) {
    try {
      const response = await api.post('/reviews', reviewData);
      return {
        success: true,
        review: response.data.review,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur création avis:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création de l\'avis'
      };
    }
  },

  /**
   * Liker/Unliker un avis
   * POST /api/reviews/:reviewId/like
   */
  async toggleLike(reviewId) {
    try {
      const response = await api.post(`/reviews/${reviewId}/like`);
      return {
        success: true,
        ...response.data
      };
    } catch (error) {
      console.error('Erreur like avis:', error);
      return {
        success: false,
        message: 'Erreur lors du like'
      };
    }
  },

  /**
   * Signaler un avis
   * POST /api/reviews/report
   */
  async reportReview(reportData) {
    try {
      const response = await api.post('/reviews/report', reportData);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur signalement avis:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du signalement'
      };
    }
  }
};

export default reviewService;